import { useMutation } from '@tanstack/react-query';

import { env } from '@/config/env';
import * as supabaseSource from '@/services/enquiries/enquiries.api';
import { type EnquiryInput, type EnquiryReceipt } from '@/services/enquiries/types';

const source = (): Promise<{ submitEnquiry: (i: EnquiryInput) => Promise<EnquiryReceipt> }> =>
  env.useMockData ? import('@/services/enquiries/mock') : Promise.resolve(supabaseSource);

/**
 * One submission per form. `isPending` disables the button, and retry is off so
 * a failed send is never silently repeated (§39).
 */
export function useSubmitEnquiry() {
  return useMutation({
    mutationFn: async (input: EnquiryInput) => (await source()).submitEnquiry(input),
    retry: 0,
  });
}
